export const events = {
  1: "cl_lnd_am30_gender_sign",
  2: "cl_lnd_am30_date_birth_sign",
  3: "cl_lnd_am30_want_member_sign",
  4: "cl_lnd_am30_email_sign",
  5: "cl_lnd_am30_password_sign",
  6: "cl_lnd_am30_reg_conf_sign",
};

export const errorEventsName = {
  empty: "err_lnd_name_noname",
  too_short: "err_lnd_name_shortname",
  invalid_chars: "err_lnd_name_symbolname",
};
export const landingId = "fa1775e918ae8f07dcb85d8de8c54aec"
export const errorEventsBirthday = {
  M: "err_lnd_age_onlymonth",
  D: "err_lnd_age_onlyday",
  Y: "err_lnd_age_onlyyear",
  MD: "err_lnd_age_onlydaymonth",
  DY: "err_lnd_age_onlydayyear",
  MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
  "This field cannot be empty.": "err_lnd_email_noemail",
  "Please enter a correct email address.": "err_lnd_email_wrongemail",
};

export const ERROR_EMAIL_ALREADY_USED =
  "This email address has already been used.";

export const ERROR_EMAIL_ALREADY_REGISTERED =
  "This email is already registered";

export const ERROR_EMAIL_INVALID = "Please enter a valid email address.";

export const ERROR_NOT_VALID_EMAIL = "Please enter a valid email";

export const errorEventsPassword = {
  empty: "err_lnd_password_nopassword",
  too_short: "err_lnd_password_shortpassword",
};

export const IS_VISIBLE_CUSTOM_AUTOCOMPLETE = false;

export const domains = [
  "@gmail.com",
  "@yahoo.com",
  "@hotmail.com",
  "@aol.com",
  "@outlook.com",
  "@comcast.net",
  "@live.com",
  "@mail.com",
  "@msn.com",
  "@att.net",
  "@icloud.com",
];

export const bodyTypes = {
  1: {
    label: "Slim",
    event: "cl_lnd_body_types_slim",
  },
  2: {
    label: "Athletic",
    event: "cl_lnd_body_types_athletic",
  },
  3: {
    label: "Muscular",
    event: "cl_lnd_body_types_muscular",
  },
  4: {
    label: "A few extra pounds",
    event: "cl_lnd_body_types_extra_pounds",
  },
  5: {
    label: "Big & Beautiful",
    event: "cl_lnd_body_types_big_beautiful",
  },
  6: {
    label: "No preference",
    event: "cl_lnd_body_types_no_preference",
  },
};

export const joinReasons = {
  9: { label: "Serious relationship", event: "cl_lnd_looking_serious" },
  10: { label: "Friendship", event: "cl_lnd_looking_friendship" },
  11: { label: "Casual chats", event: "cl_lnd_looking_casual" },
  12: { label: "Open to various connections", event: "cl_lnd_looking_open" },
};